import React, { PureComponent } from 'react';
import flow from 'lodash/flow';

import SortOptionComponent from './component';

import { withSearchInfo, withTracking } from '../../../provider';

import {
  sortOptionsFlatObj,
  getMainCategoryIdBySortId,
  getCategoryOption,
} from '../../../utils/sortOptions';

class SortOptionContainer extends PureComponent {
  onSortChange = () => {
    const {
      searchParams: { sortOption } = {},
      updateSearchQueryString,
      sortMainCategoryId,
      injected: { tracking: { trackButtonClick } = {} } = {},
    } = this.props;
    const nextValue = getCategoryOption(sortOption, sortMainCategoryId);
    const sortObject = sortOptionsFlatObj[nextValue].value;

    // At most will have one key
    const sortKey = Object.keys(sortObject)[0];
    const direction = sortObject[sortKey];

    trackButtonClick(sortKey || 'recommended', { direction });

    updateSearchQueryString({
      sort: JSON.stringify(sortObject),
      sortOption: nextValue,
    });
  };

  render() {
    const {
      searchParams: { sort, sortOption } = {},
      sortMainCategoryId,
      label,
      options,
      activeClass,
    } = this.props;

    const activeMainSortCategory = getMainCategoryIdBySortId(sortOption);
    const isActive = activeMainSortCategory === sortMainCategoryId;
    return (
      <SortOptionComponent
        activeClass={activeClass}
        isActive={isActive}
        sort={sort}
        activeOption={sortOptionsFlatObj[sortOption]}
        label={label}
        options={options}
        onSortChange={this.onSortChange}
      />
    );
  }
}

export default flow(withSearchInfo, withTracking('sort'))(SortOptionContainer);
